import styled from 'styled-components';
export const Container  = styled.div`

min-height:10vh;


`;

export const Header  = styled.div`
display: flex;
justify-content: center;
align-items: center;
height: 18vh;

`;

export const Body  = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
height: 10vh;

.primaryText{
font-family: Lato;
font-size: 28px;
font-weight: 900;
line-height: 34px;
letter-spacing: 0px;
text-align: center;

}
.secondaryText{
font-family: Lato;
font-size: 14px;
font-weight: 400;
line-height: 20px;
letter-spacing: 0em;
text-align: center;
padding-top:2vh;
}
`;

export const Footer  = styled.div`


.text{
font-family: Lato;
font-size: 12px;
font-weight: 900;
line-height: 16px;
letter-spacing: 0em;
text-align: center;

}
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
height: 10vh;
`;
export  const CloseIcon= styled.div`
position:absolute;
top:10px;
right:0px;
cursor:pointer;
`; 

